
export default {
  props: {
    theme: {
      type: String,
      default: "blue",
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
};
